import { COUNTRY_NAME, COUNTRY_SHORT_NAME } from '@commons/constants';
import { PLATFORM_KEY } from '@commons/config/platforms';

const { PEDIDOS_YA } = PLATFORM_KEY;

const COUNTRIES = [
  {
    id: 3,
    name: COUNTRY_NAME.ARGENTINA,
    live: 'https://www.pedidosya.com.ar',
    local: `/?c=.ar`,
    stg: 'https://stg-mweb.pedidosya.com.ar',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.ARGENTINA,
  },
  {
    id: 17,
    name: COUNTRY_NAME.BOLIVIA,
    live: 'https://www.pedidosya.com.bo',
    local: `/?c=.bo`,
    stg: 'https://stg-mweb.pedidosya.com.bo',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.BOLIVIA,
  },
  {
    id: 2,
    name: COUNTRY_NAME.CHILE,
    live: 'https://www.pedidosya.cl',
    local: `/?c=.cl`,
    stg: 'https://stg-mweb.pedidosya.cl',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.CHILE,
  },
  {
    id: 11,
    name: COUNTRY_NAME.PANAMA,
    live: 'https://www.pedidosya.com.pa',
    local: `/?c=.pa`,
    stg: 'https://stg-mweb.pedidosya.com.pa/',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.PANAMA,
  },
  {
    id: 15,
    name: COUNTRY_NAME.PARAGUAY,
    live: 'https://www.pedidosya.com.py',
    local: `/?c=.py`,
    stg: 'https://stg-mweb.pedidosya.com.py',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.PARAGUAY,
  },
  {
    id: 1,
    name: COUNTRY_NAME.URUGUAY,
    live: 'https://www.pedidosya.com.uy',
    local: `/?c=.uy`,
    stg: 'https://stg-mweb.pedidosya.com.uy',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.URUGUAY,
  },
  {
    id: 18,
    name: COUNTRY_NAME.DOMINICANAN_REPUBLIC,
    live: 'https://www.pedidosya.com.do',
    local: `/?c=.do`,
    stg: 'https://stg-mweb.pedidosya.com.do',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.DOMINICANAN_REPUBLIC,
  },
  {
    id: 8,
    name: COUNTRY_NAME.VENEZUELA,
    live: 'https://www.pedidosya.com.ve',
    local: `/?c=.ve`,
    stg: 'https://stg-mweb.pedidosya.com.ve',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.VENEZUELA,
  },
  {
    id: 19,
    name: COUNTRY_NAME.EL_SALVADOR,
    live: 'https://www.pedidosyasv.com.sv',
    local: `/?c=.sv`,
    stg: 'https://stg-mweb.pedidosyasv.com.sv',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.EL_SALVADOR,
  },
  {
    id: 20,
    name: COUNTRY_NAME.NICARAGUA,
    live: 'https://www.pedidosyani.com.ni',
    local: `/?c=.ni`,
    stg: 'https://stg-mweb.pedidosyani.com.ni',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.NICARAGUA,
  },
  {
    id: 7,
    name: COUNTRY_NAME.PERU,
    live: 'https://www.pedidosya.com.pe',
    local: `/?c=.pe`,
    stg: 'https://stg-mweb.pedidosya.com.pe',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.PERU,
  },
  {
    id: 13,
    name: COUNTRY_NAME.ECUADOR,
    live: 'https://www.pedidosya.com.ec',
    local: `/?c=.ec`,
    stg: 'https://stg-mweb.pedidosya.com.ec/',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.ECUADOR,
  },
  {
    id: 16,
    name: COUNTRY_NAME.COSTA_RICA,
    live: 'https://www.pedidosya.cr',
    local: `/?c=.cr`,
    stg: 'https://stg-mweb.pedidosya.cr/',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.COSTA_RICA,
  },
  {
    id: 21,
    name: COUNTRY_NAME.GUATEMALA,
    live: 'https://www.pedidosya.com.gt',
    local: `/?c=.gt`,
    stg: 'https://stg-mweb.pedidosya.com.gt/',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.GUATEMALA,
  },
  {
    id: 22,
    name: COUNTRY_NAME.HONDURAS,
    live: 'https://www.pedidosya.com.hn',
    local: `/?c=.hn`,
    stg: 'https://stg-mweb.pedidosya.com.hn/',
    platformKey: PEDIDOS_YA,
    shortName: COUNTRY_SHORT_NAME.HONDURAS,
  },
];

export default COUNTRIES.sort((a, b) => (a.name > b.name ? 1 : -1));
